import { Link } from 'react-router-dom';
import { Badge } from '../components/Badge';

interface ComingSoonProps {
  title: string;
  /** Phase se lam man hinh nay, theo lo trinh muc 15 cua dac ta. */
  phase: string;
  summary: string;
  /** Nhung thu man hinh nay se co — noi truoc de biet dang cho cai gi. */
  bullets: ReadonlyArray<string>;
  /** Ghi chu ve phan API da co san (neu co) — de khong ai tuong la chua lam gi ca. */
  apiNote?: string;
}

/**
 * Trang giai thich cho cac muc thuoc phase sau.
 *
 * Nguyen tac: KHONG bao gio dung so lieu gia hay bang trong de "trong nhu that".
 * Noi thang man hinh nay chua lam, phase nao lam, va se co gi.
 */
export function ComingSoon({ title, phase, summary, bullets, apiNote }: ComingSoonProps) {
  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <div className="flex items-center gap-2">
        <h1 className="text-lg font-semibold">{title}</h1>
        <Badge tone="warn">{phase}</Badge>
      </div>

      <section className="cf-card p-5">
        <p className="text-sm text-slate-700 dark:text-slate-300">{summary}</p>

        <h2 className="mt-4 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
          Man hinh nay se co
        </h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-slate-700 dark:text-slate-300">
          {bullets.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        {apiNote !== undefined && (
          <p className="mt-4 rounded border border-sky-300 bg-sky-50 p-2 text-sm text-sky-900 dark:border-sky-800 dark:bg-sky-950 dark:text-sky-200">
            {apiNote}
          </p>
        )}

        <p className="mt-4 text-sm text-slate-500 dark:text-slate-400">
          Trong luc cho, dung{' '}
          <Link to="/" className="cf-link">
            Tong quan
          </Link>
          ,{' '}
          <Link to="/keys" className="cf-link">
            API key
          </Link>{' '}
          va{' '}
          <Link to="/tasks" className="cf-link">
            Task
          </Link>{' '}
          — ba man hinh nay da hoat dong day du o Phase 0.
        </p>
      </section>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="mx-auto max-w-lg">
      <div className="cf-card p-6 text-center">
        <h1 className="text-lg font-semibold">Không có trang này</h1>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
          Duong dan khong khop muc nao trong thanh dieu huong.
        </p>
        <Link to="/" className="cf-btn cf-btn-primary mt-4">
          Ve tong quan
        </Link>
      </div>
    </div>
  );
}
